import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/reset.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import App from './app'
import { UserProvider } from './assets/contexts/userContext';
import { NotificationProvider, Notification } from './assets/contexts/notificationContext';
import { ConfirmProvider } from './assets/contexts/confirmContext';
import CookieModal from './components/CookieModal';

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
    <NotificationProvider>
      <ConfirmProvider>
        <UserProvider>
          <App />
          <CookieModal />
        </UserProvider>
        <Notification />
      </ConfirmProvider>
    </NotificationProvider>
  // </React.StrictMode>,
)
